export const getListOfSenderId = {
  GET_LIST_OF_SENDER_ID_REQUEST: "GET_LIST_OF_SENDER_ID_REQUEST",
  GET_LIST_OF_SENDER_ID_SUCCESS: "GET_LIST_OF_SENDER_ID_SUCCESS",
  GET_LIST_OF_SENDER_ID_ERROR: "GET_LIST_OF_SENDER_ID_ERROR",
};

export const editSenderId = {
  EDIT_SENDER_ID_REQUEST: "EDIT_SENDER_ID_REQUEST",
  EDIT_SENDER_ID_SUCCESS: "EDIT_SENDER_ID_SUCCESS",
  EDIT_SENDER_ID_ERROR: "EDIT_SENDER_ID_ERROR",
};
